export default __webpack_public_path__ + "static/media/startupstorymedia.7fbcc0b9.svg";